<template>
  <div v-if="sets">
    <div v-for="(set,index_s) in sets" :key="index_s">
      <table style="border: 1px solid #ccc" class="table " >
        <thead>
          <tr>
            <th class="table-title-col-span" colspan="9">
              <h4>Cuadro 2</h4>
              <h4 v-if="set && set.length>1">
                Programa: {{set[0].programa}}
              </h4>
            </th>
          </tr>

          <tr>
            <th class="table-title-col-span" colspan="9">
              <h4 class="subtitulo-c3">
                Análisis de Comportamiento Presupuestario año 2020 Denominación
              </h4> 
            </th>
          </tr>
          <tr>
            <th>Subt.</th>
            <th>Item</th>
            <th>Asig</th>
            <th>Denominación</th>
            <th>Presupuesto Inicial (M$)</th>
            <th>Presupuesto Final (M$)</th>
            <th>Ingresos y Gastos Devengados (M$)</th>
            <th>Diferencia (M$)</th>
            <th>Notas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in set" :key="index" :class="item.tipo">
            <td><span v-if="item.tipo==='tr_subtitulo'">{{ item.subtitulo }}</span></td>
            <td><span v-if="item.tipo==='tr_item'">{{ item.item }}</span></td>
            <td><span>{{ item.asignacion }}</span></td>
            <td>{{ item.denominacion }}</td>
            <td>{{ item.pptoInicial }}</td>
            <td>{{ item.pptoFinal }}</td>
            <td>
              <span style="color: #000">{{ item.pptoDevengados }}</span>
            </td>
            <td>
              <div v-if="item.diferencia < 0">
                <span style="color: red">{{ item.diferencia }}</span>
              </div>
              <div v-else>
                <span style="color: #000">{{ item.diferencia }}</span>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      title: "Información Procesada",
      datosTabla: null,
      items: [],
      DataSource: [],
      dateEnd: null,
      sets:null
    };
  },
  methods: {
    get_tipo(item){
      if (item.asignacion) {return "tr_asignacion"}
      if (item.item) {return "tr_item"}
      return "tr_subtitulo"
    },
    obtener: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=3&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        // this.datosTabla =
        //   res.data[0].datos.modificado[`${process.env.VUE_APP_ANIO}`];
        
        res.data[0].datos.importado.forEach(set=>{
          set.forEach((item) => {
          
            item.tipo=this.get_tipo(item)
            item.diferencia=new Intl.NumberFormat().format(item.diferencia)
            item.pptoDevengados=new Intl.NumberFormat().format(item.pptoDevengados)
            item.pptoFinal=new Intl.NumberFormat().format(item.pptoFinal)
            item.pptoInicial=new Intl.NumberFormat().format(item.pptoInicial)

        });

        this.sets = res.data[0].datos.importado


        // this.items.sort(function(a, b) {
        //   if (a.subtitulo > b.subtitulo) {
        //     return 1;
        //   }
        //   if (a.subtitulo < b.subtitulo) {
        //     return -1;
        //   }
        //   return 0;
        // });
        })

        // console.log("date-end", this.items);
        // this.items.forEach((a) => {
        //   let subtitulos;
        //   this.items.filter(function(item) {
        //     if (a.subtitulo === item.id && a.item === item.item) return;
        //     if (a.subtitulo === item.id && a.item !== item.item) {
        //       subtitulos = "";
        //     } else if (a.subtitulo !== item.subtitulo) {
        //       subtitulos = a.subtitulo;
        //     }
        //     this.DataSource.push({
        //       subtitulos,
        //       item: a.item,
        //       diferencia: a.diferencia,
        //       pptoDevengados: a.pptoDevengados,
        //       pptoFinal: a.pptoFinal,
        //       pptoInicial: a.pptoInicial,
        //       subtituloNombre: a.subtituloNombre,
        //     });
        //   });
        // });

        // let personasMap = this.DataSource.map((persona) => {
        //   return [JSON.stringify(persona), persona];
        // });
        // let personasMapArr = new Map(personasMap); // Pares de clave y valor
        // //Array Final
        // this.dateEnd = [...personasMapArr.values()];

      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.obtener();
  },
};
</script>

<style scoped>
.subtitulo-c3 {
  font-size: 0.95rem;
  font-weight: bold;
  margin: 0;
}

tr td:nth-child(2) {
  background: #ccc;
}
tr td:nth-child(4) {
  background: #ccc;
}
tr td:nth-child(6) {
  background: #ccc;
}

tr td:nth-child(8) {
  background: #ccc;
}

.total {
  display: flex;
  justify-content: space-evenly;
}

.background-color-table {
  background-color: #f5f5f5;
  margin: 0;
}

h4 {
  text-align: center;
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
}
hr {
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}

table {
  font-size: 1rem !important;
  margin: 0;
  border: 1px solid #f5f5f5;
}
thead {
  background-color: #f5f5f5;
  color: #24c6ab;
  text-align: left !important;
}
tr:hover {
  background: none !important;
  text-align: left !important;
}
th {
  font-size: 1rem !important;
  text-align: left !important;
  width: 35%;
}
.table-resaltar {
  font-weight: bold;
  background: #f5f5f5;
}
.table-resaltar:hover {
  background: #f5f5f5 !important;
}

/* td {
  text-align: left !important;
} */

.table-striped > tbody > tr:nth-child(even) > td,
.table-striped > tbody > tr:nth-child(even) > th {
  background-color: #f5f5f5;
}
.table-striped > thead > tr > th {
  background-color: #f5f5f5;
}

 tr.tr_subtitulo td{
   text-align: right;
   font-size:1rem !important;
    color:black !important;
}

tr.tr_item td{
   text-align: right;
  }

tr.tr_asignacion td{
   text-align: right;
   color:grey !important;
  }
</style>
